module.exports = __webpack_public_path__ + "static/tea-93cfd89f1bf7a75f006956ca536d37c1.jpeg";